import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error('Email is required');

    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER_DOMIN}/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok) {
        toast.success(data.message);
        navigate('/reset-password', { state: { email } });
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error('Failed to send reset link.');
    }
  };

  return (
    <div className="p-4 flex justify-center items-center min-h-[70vh]">
      <div className="bg-white shadow-lg p-6 rounded w-full max-w-md">
        <h1 className="text-2xl font-bold mb-4 text-center">Forgot Password</h1>
        <form onSubmit={handleSubmit} className="flex flex-col">
          <label className="font-semibold mb-1">Email</label>
          <input
            type="email"
            className="p-2 border rounded mb-4"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-2 rounded">
            Send Reset OTP
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
